/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
import axios from 'axios';
import { Auth } from 'aws-amplify';
import store from './redux/store';
import { execute500Handler } from './redux/actions/errorHandler';
import history from './services/history';

const _konamiApi = axios.create({
  baseURL: process.env.KONAMI_API_URL,
});

const _killshotApi = axios.create({
  baseURL: process.env.KILLSHOT_API_URL,
});

const _killshotBaseApi = axios.create({
  baseURL: process.env.KILLSHOT_API_URL,
});

const _killshotApiSG = axios.create({
  baseURL: process.env.KILLSHOT_API_URL,
});

const _hallpassApi = axios.create({
  baseURL: process.env.HALLPASS_API_URL,
});

const _mrCleanApi = axios.create({
  baseURL: process.env.MRCLEAN_API_URL,
});

const _salesStreamApi = axios.create({
  baseURL: process.env.SALES_STREAM_API_URL,
});

const _automationStationApi = axios.create({
  baseURL: process.env.AUTOMATION_STATION_API,
});

async function requestSucess(config) {
  try {
    const response = await Auth.currentSession();
    config.headers.common['Access-Token'] = response.accessToken.jwtToken;
    config.headers.common['Id-Token'] = response.idToken.jwtToken;

    const { user } = store.getState();

    if (user?.organization) {
      config.headers.common['Org-Id'] = user?.organization?.id;
    }

    return Promise.resolve(config);
  } catch (e) {
    return e;
  }
}

function requestError(error) {
  throw error;
}

function responseSuccess(response) {
  if (response.request?.responseURL.split('/')[4] === 'stubhub') {
    if (response.data.response.warning) {
      store.dispatch(execute500Handler(response.data.response.warning));
    }
  }

  return response.data;
}

async function handle403Error() {
  const response = await Auth.currentSession();
  const orgId = response.idToken?.payload['custom:organization_id'];

  if (orgId === '1') {
    history.push('/');
  } else {
    history.push('/killshot');
  }
  window.location.reload();
}

async function responseError(error) {
  store.dispatch(execute500Handler(error.message));

  if (error?.response?.status === 403) {
    handle403Error();
  }

  if (error?.response?.status === 404 && error?.request?.responseURL.split('/')[4] === 'event') {
    store.dispatch(execute500Handler(error.response?.data?.message));
  }
}

async function responseErrorWithReject(error) {
  if (error?.response?.status === 403) {
    handle403Error();
  }

  return Promise.reject(error);
}

_killshotApi.interceptors.request.use(requestSucess, requestError);
_killshotApi.interceptors.response.use(responseSuccess, responseError);

_killshotBaseApi.interceptors.request.use(requestSucess, requestError);
_killshotBaseApi.interceptors.response.use(responseSuccess, responseErrorWithReject);

_killshotApiSG.interceptors.request.use(requestSucess, requestError);
_killshotApiSG.interceptors.response.use(responseSuccess);

_hallpassApi.interceptors.request.use(requestSucess, requestError);
_hallpassApi.interceptors.response.use(responseSuccess, responseError);

_konamiApi.interceptors.request.use(requestSucess, requestError);
_konamiApi.interceptors.response.use(responseSuccess, responseError);

_mrCleanApi.interceptors.request.use(requestSucess, requestError);
_mrCleanApi.interceptors.response.use(responseSuccess, responseError);

_salesStreamApi.interceptors.request.use(requestSucess, requestError);
_salesStreamApi.interceptors.response.use(responseSuccess, responseError);

_automationStationApi.interceptors.request.use(requestSucess, requestError);
_automationStationApi.interceptors.response.use(responseSuccess, responseErrorWithReject);

export const konamiApi = _konamiApi;
export const killshotApi = _killshotApi;
export const killshotBaseApi = _killshotBaseApi;
export const killshotApiSG = _killshotApiSG;
export const hallpassApi = _hallpassApi;
export const mrCleanApi = _mrCleanApi;
export const salesStreamApi = _salesStreamApi;
export const automationStationApi = _automationStationApi;
